// Copyright (c) Microsoft Corporation. All rights reserved.
export const SomervilleTizenTvAppUserAgentId = 'FC4A1DA2-711C-4E9C-BC7F-047AF8A672EA';
export const FaradayTvAppUserAgentId = '38F12DB1-C5DB-4749-AB22-A5C9E9EF866C';
/**
 * Parses the user agent string and ensures it's what we expect to see in a packaged TV app (vs. an arbitrary web browser).
 *
 * Example Tizen user agent string (from a TV app, NOT the internet browser app):
 * Mozilla/5.0 (SMART-TV; LINUX; Tizen 6.5) AppleWebKit/537.36 (KHTML, like Gecko) 85.0.4183.93/6.5 TV Safari/537.36
 * https://developer.samsung.com/smarttv/develop/guides/fundamentals/retrieving-platform-information.html
 *
 * @param userAgent string
 * @returns boolean
 */
export const isTvAppUserAgent = (userAgent) => {
    if (!userAgent) {
        return false;
    }
    if (userAgent.includes(SomervilleTizenTvAppUserAgentId)) {
        return true;
    }
    if (userAgent.includes(FaradayTvAppUserAgentId)) {
        return true;
    }
    return false;
};
/**
 * Gets the browser version for a Tizen web app. Note that these apps don't format the the browser version in the user agent
 * as expected, and are not parsed correctly by packages like bowser.
 */
export function getTizenAppBrowserVersion(userAgent) {
    if (userAgent) {
        const versionRegex = /\d+(\.\d+)*\/\d+(\.\d+)*/i;
        const versionMatch = userAgent.match(versionRegex);
        if (versionMatch && versionMatch.length > 0) {
            return versionMatch[0];
        }
    }
    return undefined;
}
//# sourceMappingURL=isTvAppUserAgent.js.map